export default __webpack_public_path__ + "static/media/apply.939a37f4.svg";